import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/**
 * Athlete-facing coach note.
 *
 * Backend default-deny (migration ab14) means this returns null
 * unless the coach has explicitly opted at least one note into
 * athlete-visibility. The Today screen's CoachCard handles the null
 * branch by mounting with `note={null}` and rendering its empty card.
 */

export interface LatestCoachNote {
  id: number;
  content: string;
  is_pinned: boolean;
  coach_user_id: number;
  coach_name: string | null;
  created_at: string;
  updated_at: string;
}

export function useLatestCoachNote() {
  return useQuery<LatestCoachNote | null>({
    queryKey: ["athlete-latest-coach-note"],
    queryFn: async () => {
      const r = await api.get<LatestCoachNote | null>("/athlete/coach-note/latest");
      return r.data ?? null;
    },
    staleTime: 60_000,
  });
}
